import React from "react";
import Summary from "./Summary";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { ReactComponent as IconEdit } from "../../../../shared/assets/Icons/IconEdit_KE.svg";
import { ReactComponent as IconDelete } from "../../../../shared/assets/Icons/IconDelete_KE.svg";
import GenericButton from "@ui-components/Button/GenericButton";
import { setCurrentStep, updateOrder } from "@redux/slices/kontrolEdge/orderSlice";

interface SummaryProps {
  currentStep: number;
  token: string;
}

const OrderOverview: React.FC<SummaryProps> = ({ currentStep, token }) => {
  const selectedPortIndex = useAppSelector((state) => state.order.selectedPortIndex) || 0;
  const orderPayload = useAppSelector((state) => state.order.ports[selectedPortIndex]);
  const dispatch = useAppDispatch();
  console.log("Final Order Payload:", orderPayload, selectedPortIndex);

  const selectedContractMonths = orderPayload?.configuration?.term?.months || "";
  const selectedContractPrice = orderPayload?.pricing?.totalMRC || "";
  const selectedCapacityLabel = orderPayload?.configuration?.capacity?.speed || "Not specified";
  const showCrossConnect =
    orderPayload?.configuration?.crossConnect === "requireXC" ? 'Need Cross Connect' : 'Need Last Mile';
  // If crossConnectPricing is stored as a string, try converting it to number
  const selectedCrossPricing = Number(orderPayload?.configuration?.crossConnectPricing) || 0;

  const handleEdit = () => {
    // dispatch(setSelectedPort(portIndex));
    dispatch(updateOrder({ isEditing: true }));
    dispatch(setCurrentStep(1));
  };

  return (
    <div className="space-y-4">
      <div className="m-6 px-6 py-4 rounded-md border border-gray-300 bg-semantic-bg-primary">
        <div className="space-x-4 w-full flex justify-between">
          <div className="flex space-x-2">
          <GenericTag label={orderPayload?.basicInfo?.name || "Not specified"} variant="success" />
          <GenericTag label={orderPayload?.basicInfo?.tag || "Not specified"} variant="success" />
          </div>
          <div className="flex space-x-2 ">
          <GenericButton 
            variant="secondary"
            size="sm"
            isIconOnly
            onClick={handleEdit}
            slotRight={<IconEdit className="w-4 h-4" />}
          />
          <GenericButton 
            variant="secondary"
            size="sm"
            isIconOnly
            slotRight={<IconDelete className="w-4 h-4" />}
          />
          </div>
        </div>
        <div className="flex justify-between w-full py-1 mt-5">
          <h3 className="text-semantic-text-secondary">Location</h3>
          <p className="text-semantic-text-secondary">{orderPayload?.location?.facilityName || "Not specified"}</p>
        </div>
        <div className="flex justify-between w-full py-1">
          <h3 className="text-semantic-text-secondary">Port capacity - Port type</h3>
          <p className="text-semantic-text-secondary">
            {selectedCapacityLabel || " "} {" "}
            , Type {' '}
            {orderPayload?.configuration?.capacity?.type || "-"}
          </p>
        </div>
        <div className="flex justify-between w-full py-1">
          <h3 className="text-semantic-text-secondary">VLAN</h3>
          <p className="text-semantic-text-secondary">
            {orderPayload?.configuration?.vlan || "Automatic assigned"}
          </p>
        </div>
        <div className="mt-5 w-80% border-b border-gray-300">
        </div>
        <div className="flex justify-between w-full py-1">
          <h3 className="font-medium text-semantic-text-primary">{`${selectedContractMonths} Months Term`}</h3>
          <p className="font-medium text-semantic-text-primary">{`$${selectedContractPrice} / month`}</p>
        </div>
        <div className="flex justify-between w-full py-1">
          <h3 className="font-medium text-semantic-text-primary">{`${showCrossConnect}`}</h3>
          <p className="font-medium text-semantic-text-primary">{`$${selectedCrossPricing} / month`}</p>
        </div>
      </div>
      <Summary token={token} currentStep={currentStep} />
    </div>
  );
};

export default OrderOverview;
